import { LoadingButton } from "@mui/lab";
import { SxProps, useTheme } from "@mui/material";

export enum Q3DButtonType {
  "contained_cancel",
  "cancel",
  "primary",
  "disabled",
}

type Props = {
  text?: string;
  onClick?: () => void;
  icon?: JSX.Element;
  disabled?: boolean;
  height?: string;
  width?: string;
  loading?: boolean;
  type?: "default" | "error" | "warning";
  sx?: SxProps;
};

export const Q3DButton = (props: Props) => {
  const theme = useTheme();

  const btnStyle = (
    type: "default" | "error" | "warning",
    state: "default" | "hover" | "disabled"
  ) => {
    const typePalette = (theme.palette.btn as any)[type];
    switch (state) {
      case "default":
        return {
          backgroundColor: typePalette?.backgroundColor,
          border: typePalette?.border,
          color: typePalette?.color,
        };
      case "hover":
        return {
          backgroundColor: typePalette?.hover?.backgroundColor,
          border: typePalette?.hover?.border,
          color: typePalette?.hover?.color,
        };
      case "disabled":
        return {
          backgroundColor: typePalette?.disabled?.backgroundColor,
          border: typePalette?.disabled?.border,
          color: typePalette?.disabled?.color,
        };
      default:
        return {};
    }
  };

  return (
    <LoadingButton
      variant="contained"
      disabled={props.disabled}
      onClick={props.onClick}
      loading={props.loading}
      sx={{
        height: props.height,
        width: props.width,
        minWidth: "16px",
        maxWidth: "200px",
        borderRadius: "0px",
        outline: "none",
        padding: "4px 8px",
        overflow: "hidden",
        lineHeight: 1.0,
        textTransform: "none",
        boxShadow: "none",
        ...btnStyle(props.type ? props.type : "default", "default"),
        "&:hover": {
          ...btnStyle(props.type ? props.type : "default", "hover"),
          boxShadow: "none",
        },
        "&.Mui-disabled": {
          ...btnStyle(props.type ? props.type : "default", "disabled"),
          boxShadow: "none",
        },
        ...props.sx,
      }}
      startIcon={props.icon}
    >
      {props.text}
    </LoadingButton>
  );
};
